import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppState } from 'src/store/appstate';
import { selectCompanyByCompanyCode } from 'src/store/entityStores/company-selectors';
import {
  CompanyProps,
  selectAllCompanyEntities,
} from 'src/store/generated/company-record.generated';

@Injectable({ providedIn: 'root' })
export class CompanyQueryService {
  constructor(private _store: Store<AppState>) {}

  public getCompanyByCode(code: string): Observable<CompanyProps | undefined> {
    return this._store.select(selectCompanyByCompanyCode(code));
  }

  public getCompanies(): Observable<CompanyProps[]> {
    return this._store.select(selectAllCompanyEntities).pipe(map((c) => c.valueSeq().toArray()));
  }
}
